import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`const client = new PostHog(
    '<ph_project_api_key>',
    { 
        host: '<ph_client_api_host>',
        personalApiKey: 'your feature flags secure API key from step 1',
        featureFlagsPollingInterval: 30000 // Optional. Measured in milliseconds. Defaults to 30000 (30 seconds)
    }
) 
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ruby"
        }}>{`posthog = PostHog::Client.new({
  api_key: "<ph_project_api_key>",
  host: "<ph_client_api_host>",
  personal_api_key: 'your feature flags secure API key from step 1',
  feature_flags_polling_interval: 30 # Optional. Measured in seconds. Defaults to 30.
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`package main

import (
    "os"
    "time"
    "github.com/posthog/posthog-go"
)

func main() {
    client, _ := posthog.NewWithConfig(
        os.Getenv("POSTHOG_API_KEY"),
        posthog.Config{
            Endpoint:       "<ph_client_api_host>",
            PersonalApiKey: "your feature flags secure API key", // Optional, but much more performant. If this token is not supplied, then fetching feature flag values will be slower.
            DefaultFeatureFlagsPollingInterval: time.Minute * 5 // time.Duration // Optional. Defaults to 5 minutes.
            // NextFeatureFlagsPollingTick: func() time.Duration {} // Optional. Use this to sync polling intervals between instances. For an example see: https://github.com/PostHog/posthog-go/pull/36#issuecomment-1991734125
        },
    )
    defer client.Close()
    // run commands
}
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-php"
        }}>{`PostHog::init("<ph_project_api_key>",
  array('host' => '<ph_client_api_host>'),
  null, // or custom http client
 'your feature flags secure API key from step 1'
);
// NOTE: PHP currently doesn't support a poller, so you'll need to reload flags as and when needed, or re-initialize the posthog client
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`from posthog import Posthog

posthog = Posthog('<ph_project_api_key>', 
    host='<ph_client_api_host>',
    poll_interval=30, # Optional. Measured in seconds. Defaults to 30.
    personal_api_key='your feature flags secure API key from step 1'
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-csharp"
        }}>{`// Note: We don't recommend passing these in directly.
// Instead, rely on the config system and set the personal 
// api key in a secrets manager.
var client = new PostHogClient(
    new PostHogOptions {
        ProjectApiKey = "<ph_project_api_key>",
        PersonalApiKey = "your feature flags secure API key from step 1"
    });
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-java"
        }}>{`import com.posthog.server.PostHog;
import com.posthog.server.PostHogConfig;
import com.posthog.server.PostHogInterface;

PostHogConfig config = PostHogConfig.builder("<ph_project_api_key>")
    .host("<ph_client_api_host>")
    .personalApiKey("your feature flags secure API key from step 1")
    .pollIntervalSeconds(30)  // Optional. Measured in seconds. Defaults to 30.
    .build();

PostHogInterface posthog = PostHog.with(config);
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      